<template>
    <div class="container-fluid">
        <div align="left">
            <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.device_id" placeholder="Device ID"></el-input>
            <el-select clearable class="col-lg-3 col-md-4 col-sm-5 col-5" style="width: 200px" v-model="searchForm.type" placeholder="please select type">
                <el-option v-for="item in icraftieTypes" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
            <el-button @click="search()">Search</el-button>
        </div>
        <div style="margin-bottom: 6px">
            <div style="float: left;margin-top: 6px;margin-bottom: 6px">
                <b>{{total}}</b> ICrafties
            </div>
            <el-table v-tb-height="{self:this}" ref="table" border :data="list" :height="height" empty-text="Temporarily no data">
                <el-table-column align="center" prop="ud_name" label="Name"></el-table-column>
                <el-table-column align="center" prop="device_id" label="Device ID">
                    <template slot-scope="scope">
                        {{scope.row.device_id?scope.row.device_id.substring(7):''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="type" label="Type">
                    <template slot-scope="scope">
                        <span>{{scope.row.type ? icraftieTypeShow[scope.row.type].label : ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="crafite_uuid" label="Trigger ID">
                    <template slot-scope="scope">
                        {{scope.row.crafite_uuid.substring(2)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" min-width="150px" label="operator">
                    <template slot-scope="scope">
                        <a @click="toUpdate(scope.row)" v-if="scope.row.device_id">
                            <i class="el-icon-s-data update"></i>
                            Update
                        </a>
                        <a @click="Delete(scope.row)" >
                            <i class="el-icon-delete delete"></i>
                            Delete
                        </a>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="Device change" :visible.sync="updateVisible" v-if="updateVisible" @close="closeUpdate('01')" destroy-on-close top="10vh" width="450px">
            <IcraftieUpdate @closeUpdate="closeUpdate('01')"></IcraftieUpdate>
        </el-dialog>
    </div>
</template>

<script>
    import IcraftieUpdate from './icraftieUpdate.vue'

    export default {
        name: 'IcraftieDateManage',
        components: { IcraftieUpdate },
        data () {
            return {
                list: [],
                searchForm: {
                    device_id: '',
                    type: ""
                },
                chooseItem: null,
                total: 0,
                updateVisible: false,
                height: 0,
                icraftieTypes: [
                    { id: 1, label: "ICraftie" },
                    { id: 2, label: "Token" },
                    { id: 3, label: "Stickers" }
                ],
                icraftieTypeShow: [
                    { id: 0, label: " " },
                    { id: 1, label: "ICraftie" },
                    { id: 2, label: "Token" },
                    { id: 3, label: "Stickers" }
                ],
            }
        },
        computed: {},
        created () {},
        mounted () { },
        methods: {
            search () {
                this.$api.rootV1.post('/web/craftie/icraftie/get', this.searchForm, (res) => {
                    this.list = res.data
                    this.total = res.data.length
                })
            },
            Delete (crafite) {
                this.$confirm('Are you sure you want to delete all data of this icraftie?', 'prompt', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    let loading = this.$util.loading();
                    this.$api.rootV1.post(
                        "/web/craftie/icraftie/clearData",
                        { 
                            crafite_uuid: crafite.crafite_uuid,
                            device_id: crafite.device_id 
                        },
                        (res) => {
                            this.search()
                            this.$alert("Successfully clear!", "info", {
                                confirmButtonText: "confirm",
                                type: "success",
                                callback: (action) => {
                                    loading.close();
                                },
                            });
                        },
                        (res) => {
                            this.$message.error(`fail! ${res.errmsg}`);
                            loading.close();
                        }
                    );
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'cancelled!'
                    })
                })
            },
            toUpdate (row) {
                this.$util.save('icraftiesUpdate', row)
                this.updateVisible = true
            },
            closeUpdate () {
                this.$util.delete('craftiesUpdate')
                this.updateVisible = false
                this.search()
            },

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/icraftieDataManage/IcraftieDataManage.vue